import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom, of } from 'rxjs';
import { filter, map, take, timeout } from 'rxjs/operators';

/**
 * Counts requests that change data on the server (saves, signing, deletes) and
 * are still waiting for an answer. A page reload in the middle of one can cut it
 * off, so anything that reloads the page checks here first.
 */
@Injectable({ providedIn: 'root' })
export class PendingWritesService {
  private count$ = new BehaviorSubject(0);

  public begin() {
    this.count$.next(this.count$.value + 1);
  }

  public end() {
    this.count$.next(Math.max(0, this.count$.value - 1));
  }

  public isIdle(): boolean {
    return this.count$.value === 0;
  }

  /** Resolves once nothing is in flight, or after `timeoutMs` at the latest. */
  public whenIdle(timeoutMs: number): Promise<void> {
    return firstValueFrom(
      this.count$.pipe(
        filter((count) => count === 0),
        take(1),
        timeout({ first: timeoutMs, with: () => of(0) }),
        map(() => undefined),
      ),
    );
  }
}
